import { render, staticRenderFns } from "./goodsPutInRecord.vue?vue&type=template&id=20fe2803"
import script from "./goodsPutInRecord.vue?vue&type=script&lang=js"
export * from "./goodsPutInRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports